import type {ContactType, Person, ReaderCategory, User} from 'src/typings';
import {isNullOrUndefined} from 'shared/utils/custom-utils';

export function isRegistrationNonExisting(reader: User): boolean {
    return (reader.readerAccounts ?? []).some((account) => isNullOrUndefined(account.registrationDate) && isNullOrUndefined(account.registrationExpirationDate));
}

export function isReaderBlocked(reader: User): boolean {
    return (reader.readerAccounts ?? []).some((account) => account.blocked);
}

export function isReadersRegistrationExpired(reader: User): boolean {
    return (reader.readerAccounts ?? []).some((account) => account.registrationExpired);
}

export function getReaderCategory(reader: User): ReaderCategory {
    return (reader.readerAccounts ?? []).map((account) => account.readerCategory)[0];
}

export function getRegistrationExpirationDate(reader: User): string {
    return (reader.readerAccounts ?? []).map((account) => account.registrationExpirationDate)[0];
}

export function getRegistrationDate(reader: User): string {
    return (reader.readerAccounts ?? []).map((account) => account.registrationDate)[0];
}

export function getIdCardsByType(reader: Person, type: ContactType): string[] {
    return (reader.idCards ?? [])
        .filter((card) => card.type?.id === type.valueOf())
        .map((card) => card.value);
}

export function isReaderAccountValid(reader: User): boolean {
    return !(isReadersRegistrationExpired(reader) || isRegistrationNonExisting(reader));
}